import appStore from './appStore'
import appStoreBlack from './appStoreBlack'
import arrow from './arrow'
import cargo from './cargo'
import cargoMan from './cargoMan'
import check from './check'
import chevron from './chevron'
import close from './close'
import dot from './dot'
import eats from './eats'
import eatsDone from './eatsDone'
import four from './four'
import googlePlay from './googlePlay'
import googlePlayBlack from './googlePlayBlack'
import info from './info'
import like from './like'
import loader from './loader'
import locator from './locator'
import lock from './lock'
import map from './map'
import menu from './menu'
import ok from './ok'
import one from './one'
import pickUpPoint from './pickUpPoint'
import play from './play'
import plus from './plus'
import point from './point'
import rover from './rover'
import search from './search'
import three from './three'
import timer from './timer'
import two from './two'
import yandexDeliveryLogo from './yandexDeliveryLogo'
import yandexDeliveryLogoMobile from './yandexDeliveryLogoMobile'
import yandexGo from './yandexGo'
import yandexGoShortBlack from './yandexGoShortBlack'
import yandexPro from './yandexPro'
import yandexProApp from './yandexProApp'
import zoomIn from './zoomIn'
import zoomOut from './zoomOut'

const icons = {
  appStore,
  appStoreBlack,
  arrow,
  cargo,
  cargoMan,
  check,
  chevron,
  close,
  dot,
  eats,
  eatsDone,
  four,
  googlePlay,
  googlePlayBlack,
  info,
  like,
  loader,
  locator,
  lock,
  map,
  menu,
  ok,
  one,
  pickUpPoint,
  play,
  plus,
  point,
  rover,
  search,
  three,
  timer,
  two,
  yandexDeliveryLogo,
  yandexDeliveryLogoMobile,
  yandexGo,
  yandexGoShortBlack,
  yandexPro,
  yandexProApp,
  zoomIn,
  zoomOut,
}

export default icons
